import {useState , useEffect } from 'react'
import  { authCredentials } from '../../api/config'


import { getMessages, writeGalleryEntry } from '../../api/firebase'
import ImageUploader from '../ui/ImageUploader'

import styled from 'styled-components'
import Message from '../ui/Message'

const Wrapper = styled.div`
    min-height: calc(100vh-100px);
    .error_message{ 
        background-color: red;
        color: white;
        width: 100%;
        margin: auto 2rem;
        font-size: 16px;
        text-align: center;
        padding: 20px;
    }
    form{
        width: 50vw;
        padding: 20px;
        background-color: #eee;
        box-shadow: 1px 1px 4px rgba(0,0,0,0.4);
        margin: 2rem auto;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        input,label,textarea{
            width: 100%;
            border: none;
            font-size: 16px;
            border-radius: 5px;
            padding: 10px 0;
        }
        input, textarea { 
            padding-left: 1ch
        }
        label{
            margin-bottom: 2px;
            
            font-weight: bold;
        }

    }
    .btn-sbmt{
        border-radius: 10px;
        width: 100%;
        margin: 2rem ;
    }

`

const AccessedWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    textarea{
        width: 100%;
        resize: none;
        border: none;
        border-radius: 10px;

    }
`

const AdminLogin = () => {
  const [ access , setAccess ] = useState(false)
  const [username, setUsername ] = useState("")
  const [password, setPassword ] = useState("")

  const [ error , setError ] = useState("");
  const [ success , setSuccess ] = useState("")

  const [ title , setTitle ] = useState("")
  const [ description , setDescription ] = useState("")
  const [ url , setUrl ] = useState("")
  const [ collection , setCollection ] = useState("")
  const [ messages , setMessages ] = useState(null)


  useEffect(()=>{
    if( access && !messages ){
        (async ()=>{
            const response = await getMessages()
            setMessages([...response])
        })()
    }
  }, [ access , messages ])

  const handleSubmit = (e) => { 
    e.preventDefault()
    if(username == authCredentials.username && password == authCredentials.password){
        return setAccess(true)
    }
    setError("Invalid Credentials , Try Again")
    console.log(access) 
  }
  const handleUploader = async (e)=>{
      e.preventDefault()
      try {
          await writeGalleryEntry(title, description,url,collection)
          console.log('wrote success')
          setSuccess("uploaded photo to gallery successfully!")
          setTitle("")
          setDescription("")
          setUrl("")
          setTimeout(()=>{
            setSuccess("")
          }, 5000)
      } catch (error) {
          console.log('error')
          console.log(error)
          
    }

  } 
  return (
    <Wrapper >
        {!access ? <form onSubmit={handleSubmit}>
            { error && <span className='error_message'>{error}</span>}
            <h2 style={{textAlign:"center", width: "100%"}}>Admin Access</h2>
            <label htmlFor="usernmae">Username</label>
            <input name="username" type="text" id="username" value={username} onChange={e=>setUsername(e.target.value)}/>
            <label htmlFor="password">Password</label>
            <input  type="password" id="password" name="password" value={password} onChange={e=>setPassword(e.target.value)}/>
            <button className="btn-sbmt" type="submit" >Login</button>
        </form> : <AccessedWrapper>
            <h2>Welcome back Tibet!</h2>
            <h3>Upload New Photos to the Gallery</h3>
            <form onSubmit={handleUploader}>
                {success && <span>{success}</span>}
                <h3>Upload a New Photo</h3>
                <label htmlFor="title">Title</label>
                <input name="title" type="text" id="title" value={title} onChange={e=>setTitle(e.target.value)}/>
                <label htmlFor="collection">Collection Name</label>
                <input  type="text" id="collection" name="password" value={collection} onChange={e=>setCollection(e.target.value)}/>
                <label htmlFor="usernmae">Description</label>
                <textarea value={description} onChange={e=>setDescription(e.target.value)}/>
                <ImageUploader urlSetter={setUrl} />
               {
                   title && collection && access && <button className="btn-sbmt" type="submit"> Upload </button>
                }

            </form>
        
            <h3>View Messages</h3>
            {
                messages && messages.map(msg=>(
                    <Message id={msg.id} key={new Date(msg.sent).getTime()} from={msg.contactName} mailto={msg.contactEmail} message={msg.message} sent={msg.sent} subject={msg.subject} />
                ))
            }

            <h3>Edit Images</h3>


        
        
        </AccessedWrapper>}
    </Wrapper>
  )
}

export default AdminLogin